import useUser from '@/hooks/useUser';
import { PublicNarrativeEdit } from '../components/PublicNarrativeEdit';
import { NarrativeLayout } from './NarrativeLayout';
import { useMount } from '@simplywallst/ui-core';
import { NarrativeNotFound } from '../components/NarrativeNotFound';
import { useNarrativeCompany } from '../hooks/useNarrativeCompany';
import { useQueryStringParam } from '@/hooks/useQueryStringParam';
import { useExistingNarrativeRedirect } from '../hooks/useExistingNarrativeRedirect';

export const PublicNarrativeEditPage = () => {
  const { getItem } = useQueryStringParam();
  const { data: user } = useUser();

  const companyId = getItem('company')?.toLowerCase();

  const {
    data: narrativeCompany,
    status: useNarrativeCompanyStatus,
    isFetching,
  } = useNarrativeCompany(
    {
      companyId: companyId!,
    },
    {
      enabled: Boolean(companyId),
    }
  );

  const isLoading = useNarrativeCompanyStatus === 'pending';

  const isError = useNarrativeCompanyStatus === 'error';

  useExistingNarrativeRedirect({
    company: narrativeCompany?.Company,
    isEnabled: !isFetching,
  });

  useMount(() => window.scrollTo(0, 0));

  if (!user.loggedIn || !companyId) {
    return <NarrativeNotFound />;
  }

  return (
    <NarrativeLayout
      title="Edit Narrative"
      isLoading={isLoading}
      error={isError}
    >
      <PublicNarrativeEdit myNarrativeCompany={narrativeCompany?.Company} />
    </NarrativeLayout>
  );
};
